<template>
  <div class="filter-bar" role="search" :aria-label="ariaLabel">
    <q-input
      class="filter-bar__search"
      dense
      outlined
      clearable
      :model-value="modelValue"
      :label="searchLabel"
      :debounce="debounce"
      :data-testid="searchTestId || undefined"
      @update:model-value="updateSearch"
    >
      <template #prepend><q-icon name="search" aria-hidden="true" /></template>
    </q-input>
    <div v-if="$slots.quick" class="filter-bar__quick"><slot name="quick" /></div>
    <q-btn
      v-if="$slots.advanced"
      class="filter-bar__advanced-trigger"
      flat
      no-caps
      icon="filter_alt"
      label="Фильтры"
      @click="advancedOpen = true"
    />
    <q-btn
      v-if="hasFilters"
      flat
      no-caps
      icon="filter_alt_off"
      label="Сбросить"
      @click="$emit('reset')"
    />
    <div v-if="appliedFilters.length" class="filter-bar__applied" aria-label="Примененные фильтры">
      <q-chip v-for="filter in appliedFilters" :key="filter.key" dense removable @remove="$emit('remove', filter.key)">
        {{ filter.label }}
      </q-chip>
    </div>
    <q-dialog v-if="$slots.advanced" v-model="advancedOpen" position="right">
      <q-card class="filter-bar__drawer">
        <q-card-section class="row items-center">
          <h2 class="filter-bar__drawer-title">Фильтры</h2>
          <q-space />
          <q-btn flat round icon="close" aria-label="Закрыть" @click="advancedOpen = false" />
        </q-card-section>
        <q-card-section><slot name="advanced" /></q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: 'FilterBar',
  emits: ['remove', 'reset', 'search', 'update:modelValue'],
  props: {
    modelValue: { type: String, default: '' },
    searchLabel: { type: String, default: 'Поиск' },
    searchTestId: { type: String, default: '' },
    ariaLabel: { type: String, default: 'Поиск и фильтры' },
    debounce: { type: Number, default: 350 },
    hasFilters: { type: Boolean, default: false },
    appliedFilters: { type: Array, default: () => [] }
  },
  data() {
    return { advancedOpen: false }
  },
  methods: {
    updateSearch(value) {
      const normalized = value || ''
      this.$emit('update:modelValue', normalized)
      this.$emit('search', normalized)
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  flex: 1 1 42rem;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sid-space-2);
  min-width: 0;
}

.filter-bar__search { flex: 1 1 20rem; min-width: min(100%, 16rem); }
.filter-bar__quick { display: flex; align-items: center; gap: var(--sid-space-2); }
.filter-bar__applied { display: flex; flex: 1 0 100%; flex-wrap: wrap; gap: var(--sid-space-1); }
.filter-bar__drawer { width: min(24rem, 92vw); min-height: 100vh; }
.filter-bar__drawer-title { margin: 0; font-size: var(--sid-font-size-section); }
.filter-bar__advanced-trigger { display: none; }

@media (max-width: 599px) {
  .filter-bar { flex: 0 1 auto; width: 100%; align-items: stretch; flex-direction: column; flex-wrap: nowrap; }
  .filter-bar__search { flex-basis: auto; width: 100%; }
  .filter-bar__quick { display: none; }
  .filter-bar__advanced-trigger { display: inline-flex; }
  .filter-bar :deep(.q-btn) { min-height: var(--sid-touch-target); }
}
</style>
